import axios from 'axios';
import { RequestHandler } from '../../app/RequestHandler';
import { SolutionResponseProps, SolutionRequestProps } from './interfaces';

export async function getResults(solutionRequest: SolutionRequestProps): Promise<SolutionResponseProps> {
  const { language, country } = new RequestHandler();

  const url = `/eac/${language}_${country}/flowrate-calculation-backend/flowrate-calculation?`;

  const requestBody = solutionRequest;

  const options = {
    headers: {
      'Content-Type': `application/json`,
    },
  };

  const { data } = await axios.post<SolutionResponseProps>(url, JSON.stringify(requestBody), options);
  return data;
}
